import { Record } from "immutable";

export type SessionMessageType = {
  messageType?: string;
};

export type OptionalSessionMessageType = Partial<SessionMessageType>;

const defaultSessionMessage: SessionMessageType = {
  messageType: undefined
};

export default class SessionMessage extends Record(defaultSessionMessage) {}
